import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";
export default function cancelTripOrder(
  trip_id,
  reason,
  status,
  component,
  order_id
) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  fetch(`${API_URL}canceltriporder`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({ rider_id, trip_id, order_id, reason }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      api.callShippingJobs(component, trip_id);
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/cancelTripOrder.js